<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      :vertical="false"
      :timeout="timeout"
      top="top"
      :color="tipo"
      elevation="5"
      multi-line
      right
      shaped
    >
      {{ mensagem }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <h2 class="titulo mb-2">Grupos</h2>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <br />
    <v-container class="d-inline-flex align-center justify-space-between pa-0">
      <v-btn
        color="primary"
        class="btn-primary ml-0 mb-2 mr-5"
        :loading="carregando"
        @click="abrirModalGrupo(null)"
        >Adicionar</v-btn
      >
      <!-- TODO Resolver espaçamento com grid -->
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="pesquisar"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        hide-details
        class="mb-3"
      ></v-text-field>
    </v-container>

    <v-data-table
      :headers="headers"
      :search="pesquisar"
      :items="grupos"
      class="elevation-1"
      :loading="carregando"
      loading-text="Carregando informações..."
      sort-by="id"
      sort-desc
    >
      <template v-slot:[`item.dataCriacao`]="{ item }">
        <span>{{ aplicarMascaraData(item.dataCriacao) }}</span>
      </template>

      <!-- eslint-disable-next-line -->
      <template slot="no-data">
        <div v-if="erroConexao">
          <v-icon class="ml-3" color="red">mdi-alert-circle-outline</v-icon>
          <span class="ml-3 texto-erro-conexao">Erro de conexão</span>
        </div>
        <span v-if="grupos.length === 0 && !erroConexao"
          >Não há dados pra mostrar</span
        >
      </template>

      <template v-slot:[`item.options`]="{ item }">
        
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-0"
              color="primary"
              @click="abrirModalGrupo(item)"
              :disabled="!!item.dataInativacao"
              text
              icon
              v-bind="attrs"
              v-on="on">
              <v-icon> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-0 ml-2"
              color="primary"
              @click="abrirModalExcluirGrupo(item.id, item.descricao)"
              :disabled="!!item.dataInativacao"
              text
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Excluir</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <ModalGrupo
      v-if="mostrarModalGrupo"
      @fecharModal="fecharModalGrupo"
      @adicionarGrupo="adicionarGrupo"
      @erroAdicionarGrupo="erroAdicionarGrupo"
      @editarGrupo="editarGrupo"
      @erroEditarGrupo="erroEditarGrupo"
      :grupoSelecionado="grupoSelecionado"
      :funcionarios="diferencaListaFuncionarios"
    />

    <ModalExcluirGrupo
      v-if="mostrarModalExcluirGrupo"
      @fecharModal="fecharModalExcluirGrupo"
      @excluirGrupo="excluirGrupo"
      @erroExcluirGrupo="erroExcluirGrupo"
      :idGrupoSelecionado="idGrupoSelecionado"
      :isEditarGrupo="true"
      :descricaoGrupoSelecionado="descricaoGrupoSelecionado"
    />

  </v-container>
</template>

<script>
import mixinMensagen from "@/mixin/mixin-mensagem";
import ModalGrupo from "@/components/modal/ModalGrupo.vue";
import ModalExcluirGrupo from "@/components/modal/ModalExcluirGrupo.vue";
import Grupo from "@/model/grupo/Grupo";
import Funcionario from "@/model/funcionario/Funcionario";
import grupoService from "@/api/grupo/grupo-api";
import funcionarioService from "@/api/funcionario/funcionario-api";
import dataUtils from "@/utils/data";
import storage from "@/utils/storage";
import { reject } from "q";
import Usuario from "@/model/usuario/Usuario";

export default {
  components: { ModalGrupo, ModalExcluirGrupo },
  name: "Grupos",
  mixins: [mixinMensagen],
  data() {
    return {
      pesquisar: "",
      descricaoGrupoSelecionado: "",
      grupos: [],
      listaFuncionarios: [],
      diferencaListaFuncionarios: [],
      erroConexao: false,
      mostrarModalGrupo: false,
      mostrarModalExcluirGrupo: false,
      idGrupoSelecionado: 0,
      carregando: false,
      grupoSelecionado: new Grupo(),
      usuarioLogado: new Usuario(),
      headers: [
        {
          text: "Código",
          align: "start",
          value: "id",
          width: "110px",
        },
        { text: "Descrição", value: "descricao", width: "200px" },
        { text: "Data de Criação", value: "dataCriacao", width: "115px" },
        {
          text: "",
          value: "options",
          align: "right",
          width: "115px",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    abrirModalGrupo(grupo) {
      if (grupo) {
        this.grupoSelecionado = JSON.parse(JSON.stringify(grupo));
        this.obterDiferencaListaFuncionarios();
      } else {
        this.diferencaListaFuncionarios = JSON.parse(
          JSON.stringify(this.listaFuncionarios)
        );
      }
      this.mostrarModalGrupo = true;
    },
    obterDiferencaListaFuncionarios() {
      this.diferencaListaFuncionarios = this.listaFuncionarios.filter(
        (x) =>
          !this.grupoSelecionado.funcionariosGrupo.some(
            (y) => y.login === x.login
          )
      );
    },

    async fecharModalGrupo() {
      this.grupoSelecionado = new Grupo();
      this.mostrarModalGrupo = false;
    },

    abrirModalExcluirGrupo(id, descricao) {
      this.idGrupoSelecionado = id;
      this.descricaoGrupoSelecionado = descricao;
      this.mostrarModalExcluirGrupo = true;
    },

    async fecharModalExcluirGrupo() {
      this.idGrupoSelecionado = 0;
      this.descricaoGrupoSelecionado = "";
      this.mostrarModalExcluirGrupo = false;
    },

    aplicarMascaraData(data) {
      return dataUtils.aplicarMascaraEmDataIso(data);
    },

    obterUsuarioLogado() {
      this.usuarioLogado = new Usuario(storage.obterUsuarioAtualStorage());
    },

    async obterGrupos() {
      await grupoService
        .obterTodosGruposDoUsuarioLogado(this.usuarioLogado.login)
        .then((response) => {
          this.grupos = response.data.map((p) => new Grupo(p));
        })
        .catch((error) => reject(error.response));
    },

    async obterFuncionarios() {
      await funcionarioService
        .obterFuncionariosPorLoginUsuario(this.usuarioLogado.login)
        .then((response) => {
          this.listaFuncionarios = response.data.map((p) => new Funcionario(p));
        })
        .catch((error) => reject(error.response));
    },
    async obterDados() {
      this.carregando = true;
      try {
        await this.obterGrupos();
        await this.obterFuncionarios();
      } catch (error) {
        this.erroConexao = true;
        this.dispararMensagem(
          (error &&
            error.data &&
            error.data.erros &&
            error.data.erros.join(" ")) ||
            "Não foi possível se comunicar com o servidor!",
          "error",
          3000
        );
      }
      this.carregando = false;
    },

    adicionarGrupo(grupo) {
      this.grupos.push(grupo);
      this.fecharModalGrupo(grupo);
      this.dispararMensagem("Grupo adicionado com sucesso!", "success", 3000);
    },

    erroAdicionarGrupo(mensagemErro) {
      this.dispararMensagem(mensagemErro, "error", 3000);
    },

    editarGrupo(grupo) {
      let indice = this.grupos.findIndex((g) => g.id === grupo.id);
      this.grupos.splice(indice, 1, grupo);
      this.fecharModalGrupo();
      this.dispararMensagem("Grupo atualizado com sucesso!", "success", 3000);
    },

    erroEditarGrupo(mensagemErro) {
      this.dispararMensagem(mensagemErro, "error", 3000);
    },

    excluirGrupo(id) {
      let indice = this.grupos.findIndex((g) => g.id === id);
      this.grupos.splice(indice, 1);
      this.fecharModalExcluirGrupo();
      this.dispararMensagem("Grupo excluído com sucesso!", "success", 3000);
    },

    erroExcluirGrupo(mensagemErro) {
      this.dispararMensagem(mensagemErro, "error", 3000);
    },
  },

  async mounted() {
    this.obterUsuarioLogado();
    await this.obterDados();
  },
};
</script>

<style lang="scss" scoped>
.chip-min-width {
  width: 80px;
  display: flex;
  justify-content: center;
}

.chip-font-size {
  font-size: 14px;
}

.texto-erro-conexao {
  color: red;
}

.flex-row-chips {
  display: flex;
  flex-wrap: wrap;
}
</style>